export default __webpack_public_path__ + "static/media/internet-disconnected.3f50f506.png";